import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ShortNumberPipe,
  CapitalizePipe,
  EllipsisPipe,
  SafeUrlPipe,
  SafeHtmlPipe,
  SafeResourceUrlPipe
} from "./pipes";
import {NewellMatSizeDirective, NewellMatButtonTogglePrimaryDirective } from "./directives";


const pipes = [
  ShortNumberPipe,
  CapitalizePipe,
  EllipsisPipe,
  SafeUrlPipe,
  SafeHtmlPipe,
  SafeResourceUrlPipe,
];

const directives = [
  NewellMatSizeDirective,
  NewellMatButtonTogglePrimaryDirective
];

@NgModule({
  declarations: [
    ...pipes,
    ...directives,
  ],
  imports: [ CommonModule ],
  exports: [
    ...pipes,
    ...directives
  ]
})
export class NewellUtilityModule { }
